import { render } from "./ProductsList.vue?vue&type=template&id=69317bbc&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import "./ProductsList.vue?vue&type=style&index=0&id=69317bbc&lang=scss"
import "./ProductsList.vue?vue&type=style&index=1&id=69317bbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69317bbc"]])

export default __exports__